import { lmsClient } from "api";

const PDCService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

PDCService.getPDCSingle = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    loanNo: data?.loanNo,
    namaKonsumen: data?.customerName,
    branchId: data?.branchId,
  };

  return lmsClient({
    url: `/lms/PDCSingle/SearchListPDC?${buildQuery(params)}`,
    method: "get",
  });
};

PDCService.addPDCSingle = function (data) {
  return lmsClient({
    url: `/lms/PDCSingle/add`,
    method: "post",
    data: data,
  });
};

PDCService.getSearchListPDC = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    branchId: data?.branchId,
    namaKonsumen: data?.customerName, 
  };
  return lmsClient({
    url: `/lms/PDCMultiple/SearchKonsumen?${buildQuery(params)}`,
    method: "get",
  });
};

PDCService.addPDCmulti = function (data) {
  return lmsClient({
    url: `/lms/PDCMultiple/add`,
    method: "post",
    data: data,
  });
};

//  Get Loan By Konsumen
PDCService.getLoanByKonsumen = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    branchId: data?.branchId,
    namaKonsumen: data?.customerName,
    loanNo: data?.loanNo,
  };

  return lmsClient({
    url: `/lms/PDCMultiple/LoanByKonsumen?${buildQuery(params)}`,
    method: "get",
  });
};

export default PDCService;
